/**
 * Dealer contact analytics (Milestone 11 / M15).
 */
import { trackBuyerEvent } from "./buyerAnalytics";
import { toListingAnalyticsPayload } from "./automapListing/listingViewModels";
import { DEALER_CONTACT_ANALYTICS_EVENTS } from "../constants/automapDealerTrustConstants";
import { getDealerTrustViewModel } from "./dealerTrustViewModel";

export { DEALER_CONTACT_ANALYTICS_EVENTS };

export function buildDealerContactAnalyticsPayload(listing, dealer = null, extra = {}) {
  const trust = listing ? getDealerTrustViewModel(listing, dealer, { slug: extra.slug }) : null;
  const base = listing
    ? toListingAnalyticsPayload(listing, {
        listingSlug: listing.slug || listing.id || null,
        dealerName: trust?.dealerName || listing.dealerName || null,
        dealerVerified: trust?.isVerified ?? Boolean(listing.dealerVerified),
        dealerVerificationStatus: trust?.verificationStatus || listing.dealerVerificationStatus || null,
        ...extra,
      })
    : { ...extra };

  return {
    ...base,
    dealerId: trust?.dealerId || listing?.dealerId || extra.dealerId || null,
    contactMethod: extra.contactMethod || null,
    attributionContext: extra.attributionContext || null,
    sourceAction: extra.sourceAction || null,
  };
}

export function trackDealerContactEvent(eventType, listing, dealer = null, extra = {}) {
  trackBuyerEvent(eventType, buildDealerContactAnalyticsPayload(listing, dealer, extra));
}
